// src/components/DeliverySlotSelector.jsx
import React from "react";

const DeliverySlotSelector = ({ value, onChange }) => {
  return (
    <div className="mb-4">
      <label className="block text-green-700 font-medium mb-2">Select Delivery Slot:</label>
      <div className="flex gap-4">
        {["Morning", "Evening"].map((slot) => (
          <button
            key={slot}
            onClick={() => onChange(slot)}
            className={`px-4 py-2 rounded-xl border ${
              value === slot
                ? "bg-green-600 text-white"
                : "bg-white text-green-700 border-green-300"
            }`}
          >
            {slot}
          </button>
        ))}
      </div>
      <div className="text-xs text-gray-500 mt-2">
        Choose the best or required slot for your delivery. If not selected, <span className="font-semibold text-green-700">Morning</span> will be chosen by default.
      </div>
    </div>
  );
};

export default DeliverySlotSelector;
